// document.addEventListener("DOMContentLoaded", () => {
//   const headerWrapper = document.querySelector(".header-wrapper");
//   const menuItems = document.querySelectorAll(".header__inline-menu > ul > li");

//   if (!headerWrapper) return;

//   headerWrapper.addEventListener("click", () => {
//     headerWrapper.classList.add("menu-active,color-scheme-1");
//   });

//   menuItems.forEach(item => {
//     const megaMenu = item.querySelector(".mega-menu__content");

//     if (!megaMenu) return;

//     // Show on hover
//     item.addEventListener("mouseenter", () => {
//       megaMenu.classList.add("mega-menu--open");
//       headerWrapper.classList.add("menu-active");
//     });

//     // Hide on out
//     item.addEventListener("mouseleave", () => {
//       megaMenu.classList.remove("mega-menu--open");
//       headerWrapper.classList.remove("menu-active");
//     });
//   });
// });
// document.addEventListener("click", function(e){

//   const nextBtn = e.target.closest(".slider-button--next");
//   const prevBtn = e.target.closest(".slider-button--prev");

//   if(!nextBtn && !prevBtn) return;

//   const slider = e.target.closest("media-gallery")?.querySelector(".quickadd-gallery");
//   if(!slider) return;

//   const slideWidth = slider.querySelector(".product__media-item")?.offsetWidth || 300;

//   if(nextBtn){
//     slider.scrollBy({
//       left: slideWidth,
//       behavior: "smooth"
//     });
//   }

//   if(prevBtn){
//     slider.scrollBy({
//       left: -slideWidth,
//       behavior: "smooth"
//     });
//   }

// });

document.addEventListener("DOMContentLoaded", function () {
  const textarea = document.getElementById("ContactForm-body");

  if (!textarea) return;

  const autoResize = () => {
    if (textarea.value.trim() === "") {
      textarea.style.height = "53px"; // reset when empty
    } else {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  };

  // Run on load (important)
  autoResize();

  // Run on input
  textarea.addEventListener("input", autoResize);
});